import { Routes } from '@angular/router';
import { CustomerCartOrBannerComponent } from './pages/customer-cart-or-banner/customer-cart-or-banner.component';

export const routes: Routes = [
  {
    path: 'main',
    loadChildren: () =>
      import('./pages/main/main-routing').then((m) => m.MAIN_ROUTES),
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/auth/auth-routing').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'branch/:branchId/customer-cart',
    component: CustomerCartOrBannerComponent,
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
];
